import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap, of } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class JsonDataService {

  constructor(private http: HttpClient, public utils: UtilsService, @Inject(PLATFORM_ID) private platformId: Object) { }

  getAboutUsJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/aboutUs.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders}).pipe(catchError(this.utils.processError.bind(this)));
  }
  getGlobalSearchJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/globalSearch.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getFormFieldsMockJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/formFieldsMock.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getProductListingMetaDataJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/productListingMetaData.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getCustomerCareInfoMetaJsonData(): Observable<any> {
    const url = this.utils.blobUrl + '/assets/json/customerCareInfo.json';
      return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(
        catchError(this.utils.processError.bind(this))
      );
  }
  getnavBarStaticDataJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/navBarStaticData.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getworkatluminousJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/workatluminous.json';
    return this.http.get<any>(url,{ headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getMetaDataJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/staticPageMetaData.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getOfferCardsJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/offercards.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  getTermsJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/terms-condition-offers.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
  comparePlpData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/plpcompare.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders}).pipe(catchError(this.utils.processError.bind(this)));
  }
  getHelpSupportJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/helpSupport.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders}).pipe(catchError(this.utils.processError.bind(this)));
  }
  getContactDetailsJsonData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/contact-details.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders}).pipe(catchError(this.utils.processError.bind(this)));
  }
    getMonsoonDaysData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/monsoon-days.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
    getsnapminttermandconditionData(): Observable<any> {
    let url = this.utils.blobUrl+ '/assets/json/snapmint-offer-terms-condition.json';
    return this.http.get<any>(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
}
